/* ============================================================
   CULT RACING — Static homepage (Shopify)
   Product cards are server-rendered by Liquid from the `static`
   collection; this wires hover, the swipe reel, and the REAL
   Shopify cart (/cart/add.js, /cart.js, /cart/change.js).
   ============================================================ */
(function () {
  "use strict";

  /* ---------- HERO VIDEO: device source + mobile-safe autoplay ---------- */
  (function initHero() {
    var v = document.getElementById("heroVideo");
    if (!v) return;
    // Source and poster are chosen by the inline script beside the <video> in
    // index.liquid, during parse, so only one file is ever requested. Do not
    // set src or call load() here: this script runs at end of body, so doing
    // the swap here delayed the hero fetch and caused a duplicate request.
    v.muted = true; v.setAttribute("muted", ""); v.playsInline = true;
    function play() { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    play();
    v.addEventListener("loadeddata", play, { once: true });
    v.addEventListener("canplay", play, { once: true });
    ["touchstart", "pointerdown", "click", "scroll"].forEach(function (ev) {
      window.addEventListener(ev, function once() { play(); window.removeEventListener(ev, once); }, { once: true, passive: true });
    });
  })();

  /* ---------- helpers ---------- */
  var money = function (cents) { return "$" + (cents / 100).toFixed(2); };
  var els = {
    count: document.getElementById("cartCount"),
    headCount: document.getElementById("cartHeadCount"),
    body: document.getElementById("cartBody"),
    subtotal: document.getElementById("cartSubtotal"),
    checkout: document.getElementById("checkoutBtn"),
    drawer: document.getElementById("cart"),
    overlay: document.getElementById("cartOverlay"),
    toast: document.getElementById("toast")
  };

  /* ---------- SHOPIFY CART (real, drawn optimistically) ----------
     The drawer opens on tap and renders the line from data already in the DOM, then
     upgrades to the server's line when /cart/add.js lands and reconciles totals from
     /cart.js in the background. Waiting on the network before opening meant the drawer
     slid open showing "your bag is empty" for ~220ms on the very act of adding. */
  var cartState = { item_count: 0, total_price: 0, items: [] };
  var inFlight = Object.create(null);
  var busy = function () { for (var k in inFlight) return true; return false; };

  function recount() {
    cartState.item_count = cartState.items.reduce(function (a, l) { return a + l.quantity; }, 0);
    cartState.total_price = cartState.items.reduce(function (a, l) { return a + l.final_line_price; }, 0);
  }
  function applyCart(cart) { cartState = cart; render(cartState); }
  /* a background refresh must never clobber an optimistic state mid-add */
  function applyCartIfIdle(cart) { if (!busy()) applyCart(cart); }

  function addToCart(variantId, label, btn) {
    if (inFlight[variantId]) return; // second tap during the request would silently add a 2nd unit
    inFlight[variantId] = true;
    if (btn) btn.classList.add("is-adding");

    var card = btn && btn.closest(".product-card");
    var frontImg = card && card.querySelector("img.front");
    var priceCents = btn ? parseInt(btn.dataset.price, 10) : 0;
    if (isNaN(priceCents)) priceCents = 0;

    // draw it before the network round trip
    var existing = null, i;
    for (i = 0; i < cartState.items.length; i++) {
      if (String(cartState.items[i].id) === String(variantId)) { existing = cartState.items[i]; break; }
    }
    if (existing) {
      existing.quantity += 1;
      existing.final_line_price += priceCents;
    } else {
      cartState.items.push({
        id: variantId, key: null, pending: true,
        product_title: label || "Item",
        variant_title: btn ? btn.textContent.trim() : "",
        quantity: 1,
        final_line_price: priceCents,
        image: frontImg ? frontImg.src : ""
      });
    }
    recount(); render(cartState);
    openCart(); showToast((label || "Item") + " added"); bumpCount();

    function settled() { delete inFlight[variantId]; if (btn) btn.classList.remove("is-adding"); }

    fetch("/cart/add.js", {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    }).then(function (r) { if (!r.ok) throw new Error("add failed"); return r.json(); })
      .then(function (res) {
        // swap THIS variant's placeholder for the server's authoritative line. Only this one:
        // clearing every pending row would erase a second add that is still in flight.
        var added = (res && res.items) || [];
        cartState.items = cartState.items.filter(function (l) {
          return !(l.pending && String(l.id) === String(variantId));
        });
        added.forEach(function (line) {
          var idx = -1;
          for (var j = 0; j < cartState.items.length; j++) {
            if (cartState.items[j].key === line.key) { idx = j; break; }
          }
          if (idx > -1) cartState.items[idx] = line; else cartState.items.push(line);
        });
        recount(); render(cartState);
        settled();
        refresh(); // authoritative totals; the user never waits on this
      })
      .catch(function () {
        // undo only this variant's optimistic add, for the same reason as above
        for (var m = 0; m < cartState.items.length; m++) {
          if (String(cartState.items[m].id) !== String(variantId)) continue;
          var line = cartState.items[m];
          if (line.pending || line.quantity <= 1) cartState.items.splice(m, 1);
          else { line.quantity -= 1; line.final_line_price -= priceCents; }
          break;
        }
        recount(); render(cartState);
        showToast("Couldn't add. Try again.");
        settled();
        refresh();
      });
  }
  function removeItem(key) {
    fetch("/cart/change.js", {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function (r) { return r.json(); }).then(applyCart).then(bumpCount);
  }
  function refresh() { return fetch("/cart.js").then(function (r) { return r.json(); }).then(applyCartIfIdle); }

  function render(cart) {
    var q = cart.item_count;
    els.count.textContent = q;
    els.count.dataset.empty = q === 0 ? "true" : "false";
    els.headCount.textContent = q ? "(" + q + ")" : "";
    els.subtotal.textContent = money(cart.total_price);
    // block checkout while a line is still optimistic — the server cart may not have it yet
    var pending = cart.items.some(function (l) { return l.pending; });
    els.checkout.disabled = q === 0 || pending;
    if (!cart.items.length) {
      els.body.innerHTML =
        '<div class="cart__empty"><svg viewBox="0 0 24 24" width="46" height="46">' +
        '<path d="M6 7h12l-1 13H7L6 7Z" fill="none" stroke="currentColor" stroke-width="1.3"/>' +
        '<path d="M9 7a3 3 0 0 1 6 0" fill="none" stroke="currentColor" stroke-width="1.3"/></svg>' +
        "<p>Your bag is empty.<br>Go claim a fit.</p></div>";
      return;
    }
    els.body.innerHTML = cart.items.map(function (l) {
      return '<div class="cart-item">' +
        '<img class="cart-item__thumb" src="' + (l.image || "") + '" alt="">' +
        '<div class="cart-item__info"><h4>' + l.product_title + "</h4><p>Size " + l.variant_title +
        (l.quantity > 1 ? " · x" + l.quantity : "") + "</p></div>" +
        '<div class="cart-item__right"><span class="cart-item__price">' + money(l.final_line_price) + "</span>" +
        (l.key
          ? '<button class="cart-item__remove" data-remove="' + l.key + '">Remove</button>'
          : '<span class="cart-item__remove is-pending">Adding</span>') +
      "</div></div>";
    }).join("");
    els.body.querySelectorAll("[data-remove]").forEach(function (b) {
      b.addEventListener("click", function () { removeItem(b.dataset.remove); });
    });
  }

  /* size buttons (server-rendered) -> add real variant */
  document.querySelectorAll(".size-btn").forEach(function (btn) {
    if (btn.disabled) return;
    btn.addEventListener("click", function (e) {
      e.stopPropagation();
      addToCart(btn.dataset.variantId, btn.dataset.title, btn);
    });
  });

  function bumpCount() { els.count.classList.remove("bump"); void els.count.offsetWidth; els.count.classList.add("bump"); }
  var toastTimer;
  function showToast(msg) {
    els.toast.textContent = msg; els.toast.classList.add("show");
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { els.toast.classList.remove("show"); }, 2200);
  }

  /* drawer */
  function openCart() {
    els.overlay.hidden = false;
    requestAnimationFrame(function () { els.overlay.classList.add("show"); });
    els.drawer.classList.add("open"); els.drawer.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add("cart-open"); // freeze the page behind the drawer
  }
  function closeCart() {
    els.overlay.classList.remove("show"); els.drawer.classList.remove("open");
    els.drawer.setAttribute("aria-hidden", "true");
    document.documentElement.classList.remove("cart-open");
    setTimeout(function () { els.overlay.hidden = true; }, 350);
  }
  document.getElementById("cartToggle").addEventListener("click", openCart);
  document.getElementById("cartClose").addEventListener("click", closeCart);
  els.overlay.addEventListener("click", closeCart);
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeCart(); });
  els.checkout.addEventListener("click", function () { window.location.href = "/checkout"; });

  refresh(); // sync drawer with any existing Shopify cart on load

  /* nav scroll + progress bar */
  var nav = document.getElementById("nav");
  var progress = document.getElementById("scrollProgress");
  function onScroll() {
    var y = window.scrollY;
    nav.classList.toggle("scrolled", y > 40);
    var h = document.documentElement.scrollHeight - window.innerHeight;
    progress.style.width = (h > 0 ? (y / h) * 100 : 0) + "%";
  }
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();
  var yEl = document.getElementById("year"); if (yEl) yEl.textContent = new Date().getFullYear();

  /* reveal on scroll */
  if ("IntersectionObserver" in window) {
    var revObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add("in"); revObs.unobserve(en.target); } });
    }, { threshold: 0.15, rootMargin: "0px 0px -8% 0px" });
    document.querySelectorAll(".reveal").forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight * 0.92) el.classList.add("in"); else revObs.observe(el);
    });
  } else { document.querySelectorAll(".reveal").forEach(function (el) { el.classList.add("in"); }); }

  /* pause hero when off-screen */
  if ("IntersectionObserver" in window) {
    var heroObs = new IntersectionObserver(function (entries) {
      var v = document.getElementById("heroVideo");
      entries.forEach(function (en) { if (en.isIntersecting) { v.play && v.play().catch(function () {}); } else { v.pause && v.pause(); } });
    }, { threshold: 0 });
    var heroEl = document.querySelector(".hero"); if (heroEl) heroObs.observe(heroEl);
  }

  /* ---------- MOBILE: auto-reveal the product centred in the viewport ---------- */
  (function initAutoReveal() {
    var noHover = window.matchMedia("(hover:none)").matches ||
                  window.matchMedia("(pointer:coarse)").matches ||
                  (navigator.maxTouchPoints || 0) > 0;
    if (!noHover || !("IntersectionObserver" in window)) return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { en.target.classList.toggle("is-active", en.isIntersecting); });
    }, { rootMargin: "-45% 0px -45% 0px", threshold: 0 });
    document.querySelectorAll(".product-card").forEach(function (c) { obs.observe(c); });
  })();

  /* ---------- REEL: native swipe carousel + stop-to-play ---------- */
  (function initReel() {
    var reel = document.getElementById("reel");
    var viewport = document.getElementById("reelViewport");
    var track = document.getElementById("reelTrack");
    if (!reel || !viewport || !track) return;
    var cards = [].slice.call(track.querySelectorAll(".reel__card"));
    var bar = document.getElementById("reelBar");
    var swipe = document.getElementById("reelSwipe");

    var playingIndex = -1;
    function pauseAll() {
      if (playingIndex === -1) return;
      cards.forEach(function (c) { var v = c.querySelector("video"); if (v && !v.paused) v.pause(); });
      playingIndex = -1;
    }
    function playCentred() {
      var centre = viewport.scrollLeft + viewport.clientWidth / 2;
      var best = -1, bestD = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var mid = cards[i].offsetLeft + cards[i].offsetWidth / 2;
        var d = Math.abs(mid - centre);
        if (d < bestD) { bestD = d; best = i; }
      }
      if (best === playingIndex) return;
      cards.forEach(function (c, i) {
        var v = c.querySelector("video"); if (!v) return;
        if (i === best) { v.play && v.play().catch(function () {}); } else if (!v.paused) { v.pause(); }
      });
      playingIndex = best;
    }
    function updateBar() {
      if (!bar) return;
      var max = viewport.scrollWidth - viewport.clientWidth;
      bar.style.width = (max > 0 ? (viewport.scrollLeft / max) * 100 : 0) + "%";
    }
    var idle = null, hinted = false;
    viewport.addEventListener("scroll", function () {
      updateBar();
      if (!hinted && swipe) { swipe.classList.add("hide"); hinted = true; }
      pauseAll();
      clearTimeout(idle); idle = setTimeout(playCentred, 140);
    }, { passive: true });

    var down = false, startX = 0, startScroll = 0;
    viewport.addEventListener("pointerdown", function (e) {
      if (e.pointerType !== "mouse") return;
      down = true; startX = e.clientX; startScroll = viewport.scrollLeft; viewport.style.cursor = "grabbing";
      try { viewport.setPointerCapture(e.pointerId); } catch (_) {}
    });
    viewport.addEventListener("pointermove", function (e) { if (down) viewport.scrollLeft = startScroll - (e.clientX - startX); });
    function endDrag(e) { if (down) { down = false; viewport.style.cursor = ""; try { viewport.releasePointerCapture(e.pointerId); } catch (_) {} } }
    viewport.addEventListener("pointerup", endDrag);
    viewport.addEventListener("pointercancel", endDrag);

    updateBar();
    setTimeout(playCentred, 250);
    window.addEventListener("resize", updateBar);
    window.addEventListener("load", function () { updateBar(); playCentred(); });
  })();

  /* ---------- JOIN form -> Omnisend (via Cloudflare proxy) ---------- */
  (function initJoinForm() {
    var form = document.getElementById("joinForm");
    if (!form) return;
    var note = document.getElementById("joinNote");
    var success = document.getElementById("joinSuccess");
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      // consent is required to submit: the box is no longer pre-ticked, and the
      // submit is intercepted, so native validation would never fire on its own.
      var joinConsent = document.getElementById("joinConsent");
      if (!form.name.value.trim() || !form.email.value.trim() || !joinConsent.checked) { form.reportValidity(); return; }
      var btn = form.querySelector("button[type=submit]");
      btn.disabled = true; if (note) note.textContent = "Joining...";
      fetch("https://cult-racing.pages.dev/api/join", {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: form.name.value.trim(), email: form.email.value.trim(),
          phone: form.phone.value.trim(), instagram: form.instagram.value.trim(),
          company: form.company.value, // honeypot
          consent: document.getElementById("joinConsent").checked
        })
      }).then(function (r) { return r.json(); })
        .then(function (d) {
          if (d && d.ok) { form.hidden = true; if (success) success.hidden = false; }
          else { if (note) note.textContent = "Something went wrong. Try again."; btn.disabled = false; }
        })
        .catch(function () { if (note) note.textContent = "Something went wrong. Try again."; btn.disabled = false; });
    });
  })();
})();
